import {Component, computed, input} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {CalendarIcon, LucideAngularModule} from 'lucide-angular';
import {VenuePipe} from '@domain/venue/pipe/venue.pipe';
import {ActivityDTO} from '@domain/activity/activity.dto';
import {ActivityScheduleUtil} from '@domain/activity/schedule/activity-schedule.util';
import {
  ScheduleDisplayComponent
} from '@domain/activity/schedule/component/schedule-display/schedule-display.component';

@Component({
  selector: 'app-activity-schedules',
  providers: [
    VenuePipe
  ],
  imports: [
    TranslocoDirective,
    LucideAngularModule,
    ScheduleDisplayComponent
  ],
  templateUrl: './activity-schedules.component.html'
})
export class ActivitySchedulesComponent {

  public readonly activity = input.required<ActivityDTO | null>();
  public readonly isPreview = input.required<boolean>();

  public readonly icons = {
    calendar: CalendarIcon,
  };

  public readonly schedules = computed(() => this.activity()?.schedules ?? []);
  public readonly activeSchedules = computed(() => this.schedules().filter(s => s.venue && !ActivityScheduleUtil.isFinished(s)));
  public readonly sortedSchedules = computed(() => ActivityScheduleUtil.sort(this.activeSchedules()));


}
